<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="className"
  >
    <path d="m11 19-6-6" />
    <path d="m5 21-2-2" />
    <path d="m8 16-4 4" />
    <path d="M9.5 17.5 21 6V3h-3L6.5 14.5" />
  </svg>
</template>

<script>
export default {
  name: 'IconSword',
  props: {
    size: {
      type: [Number, String],
      default: 24
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
